import { DefaultError, useQuery } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';

export const useCurrentServiceCode = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, failure, success } = useQueryToast('useCurrentServiceCode');
  return useQuery<any, DefaultError>({
    queryKey: ['userManagement', 'serviceCode'],
    async queryFn() {
      loading(i18next.t('service-message.service-code.loading'));
      const response = await apiClient({
        method: 'GET',
        url: 'UserManagement/CurrentServiceCode',
      });

      return responseHandler(response, {
        groupName: 'useCurrentServiceCode',
        onSuccess: data => {
          success(i18next.t('service-message.service-code.success'));
        },
        onError: () =>
          failure(i18next.t('service-message.service-code.failure')),
      });
    },
  });
};
